import { Moment } from 'moment';
import React, { useState, useEffect, useRef } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';

import axios from '../../services/MyAxios';
import DonutChart from '../DonutChart';

import 'react-perfect-scrollbar/dist/css/styles.css';
import Card from '../common/Card';

import SpinnerGrowLoading from './SpinnerGrowLoading';

type Props = {
    url: string;
    label: string;
    startDate: Moment | null;
    endDate: Moment | null;
};

export default function PartitionMetric({ url, label, startDate, endDate }: Props) {
    const [data, setData] = useState({
        totalSum: 0,
        values: [],
    });
    const [isLoading, setIsLoading] = useState(true);
    const requestController = useRef(new AbortController());

    useEffect(updateData, [startDate, endDate]);

    useEffect(() => () => requestController.current.abort(), []);

    function updateData() {
        if (!startDate) {
            return;
        }

        let params = {}; // all-time filter

        if (startDate.isValid()) {
            if (endDate) {
                params = {
                    start_date: startDate.format(),
                    end_date: endDate.format(),
                };
            } else {
                params = { single_date: startDate.format() };
            }
        }

        setIsLoading(true);

        axios
            .get(url, {
                params,
                signal: requestController.current.signal,
            })
            .then((response) => {
                setIsLoading(false);
                setData(response.data);
            });
    }

    const legend = (
        <PerfectScrollbar>
            <div className="metrics_container">
                <ul className="metrics_legend">
                    {data?.values?.map(({ name, count }, index) => (
                        <li key={`${name} ${index + 1}`}>
                            {name} ({count} - {((count / data.totalSum) * 100).toFixed(2)}%)
                        </li>
                    ))}
                </ul>
            </div>
        </PerfectScrollbar>
    );

    return (
        <Card>
            <div className="d-flex">
                <span className="text-muted">{label}</span>
                <SpinnerGrowLoading isLoading={isLoading}>
                    <h3 className="font-light m-b-5 ml-auto">{data.totalSum}</h3>
                </SpinnerGrowLoading>
            </div>
            <div className="d-flex">
                <div className="partition-metric-legend">{legend}</div>
                <div className="partition-metric-chart">
                    <DonutChart data={data.values} />
                </div>
            </div>
        </Card>
    );
}
